/** Interval to refresh datasets and timestamps in the debugger (ms) */
export const REFRESH_INTERVAL_MS = 1000;

/** How long to show success/error feedback after invalidation (ms) */
export const INVALIDATION_FEEDBACK_MS = 2000;

/** Maximum tree depth to auto-expand in the Browse tab */
export const AUTO_EXPAND_DEPTH = 1;

/** Duration of the green border flash when data arrives (ms) */
export const DATA_FLASH_DURATION_MS = 1500;

/** Default panel width in windowed mode (px) */
export const DEFAULT_PANEL_WIDTH = 620;

/** Minimum panel width when resizing (px) */
export const MIN_PANEL_WIDTH = 360;

export type PanelMode = 'windowed' | 'fullscreen';

export const WS_STATUS = {
  connected: {
    dot: 'bg-[var(--text-color-positive)]',
    label: 'Connected',
  },
  connecting: {
    dot: 'bg-[var(--text-color-info)] animate-pulse',
    label: 'Connecting',
  },
  disconnected: {
    dot: 'bg-[var(--text-color-caution)]',
    label: 'Fallback tRPC',
  },
} as const;

export const MSG_TYPE_CLASS = {
  status: 'bg-fillHighlight text-highlightOnFill border-highlight',
  send: 'bg-fillInfo text-infoOnFill border-info',
  receive: 'bg-fillPositive text-positiveOnFill border-positive',
  error: 'bg-fillCritical text-criticalOnFill border-critical',
} as const;

export function formatTimeAgo(
  timestamp: number | undefined,
  now: number
): string {
  if (!timestamp) return '';
  const diffMs = now - timestamp;
  if (diffMs < 0) return 'just now';

  const seconds = Math.floor(diffMs / 1000);
  if (seconds < 60) return `${seconds}s ago`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  return `${Math.floor(hours / 24)}d ago`;
}

export function formatCountdown(
  dataUpdatedAt: number | undefined,
  pollIntervalMs: number | false,
  now: number
): string | null {
  if (!dataUpdatedAt || pollIntervalMs === false) return null;
  const remainingMs = dataUpdatedAt + pollIntervalMs - now;
  if (remainingMs <= 0) return 'now';
  const secs = Math.ceil(remainingMs / 1000);
  return secs >= 60 ? `${Math.ceil(secs / 60)}m` : `${secs}s`;
}
